import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiCaller } from "../../helper";

export const fetchSidebarData = createAsyncThunk(
  "sidebar/fetchSidebarData",
  async () => {
    const url = "/sidebar";
    const { data } = await apiCaller(url, "GET");
    return data;
  }
);

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSidebarData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSidebarData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSidebarData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default sidebarSlice.reducer;
